(() => {
  const cleanups = new WeakMap();
  const desktop = matchMedia('(min-width: 48rem)');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const ease = (value) => value * value * (3 - (2 * value));
  const clamp = (value) => Math.min(1, Math.max(0, value));

  function init(root) {
    if (cleanups.has(root)) return;
    const intro = root.querySelector('[data-story-intro]');
    const introStage = root.querySelector('.dra-ana-story-intro-stage');
    const chapter = root.querySelector('[data-story-chapter]');
    const media = root.querySelector('[data-story-media]');
    const narrative = root.querySelector('[data-story-narrative]');
    if (!intro || !introStage || !chapter || !media || !narrative) return;
    let frame = null;

    const clearStyles = () => [intro, media, narrative].forEach((target) => {
      target.style.removeProperty('opacity');
      target.style.removeProperty('transform');
    });
    const render = () => {
      if (!root.classList.contains('is-ready')) return;
      const stageRect = introStage.getBoundingClientRect();
      const transitionDistance = Math.max(1, stageRect.height - window.innerHeight);
      const progress = clamp(-stageRect.top / transitionDistance);
      const introProgress = ease(clamp(progress / 0.72));
      const chapterProgress = ease(clamp((progress - 0.48) / 0.47));

      root.dataset.storyProgress = progress.toFixed(3);
      intro.style.opacity = `${1 - introProgress}`;
      intro.style.transform = `scale(${1 - introProgress * 0.025})`;
      media.style.opacity = `${chapterProgress}`;
      media.style.transform = `translate3d(0, ${(1 - chapterProgress) * 1.25}rem, 0)`;
      narrative.style.opacity = `${chapterProgress}`;
      narrative.style.transform = `translate3d(0, ${(1 - chapterProgress) * 1.25}rem, 0)`;
    };
    const requestRender = () => {
      if (frame !== null) return;
      frame = requestAnimationFrame(() => {
        try {
          render();
        } finally {
          frame = null;
        }
      });
    };
    const setup = () => {
      root.classList.remove('is-ready');
      delete root.dataset.storyProgress;
      clearStyles();

      if (!desktop.matches || reducedMotion.matches) {
        return;
      }

      root.classList.add('is-ready');
      requestRender();
    };

    window.addEventListener('scroll', requestRender, { passive: true });
    window.addEventListener('resize', setup, { passive: true });
    window.addEventListener('pageshow', setup);
    desktop.addEventListener('change', setup);
    reducedMotion.addEventListener('change', setup);
    setup();
    cleanups.set(root, () => {
      window.removeEventListener('scroll', requestRender);
      window.removeEventListener('resize', setup);
      window.removeEventListener('pageshow', setup);
      desktop.removeEventListener('change', setup);
      reducedMotion.removeEventListener('change', setup);
      if (frame !== null) cancelAnimationFrame(frame);
      frame = null;
      root.classList.remove('is-ready');
      delete root.dataset.storyProgress;
      clearStyles();
      cleanups.delete(root);
    });
  }

  const rootsIn = (scope) => [
    ...(scope.matches?.('[data-dra-story]') ? [scope] : []),
    ...scope.querySelectorAll('[data-dra-story]'),
  ];
  const initScope = (scope = document) => rootsIn(scope).forEach(init);
  const cleanupScope = (scope) => rootsIn(scope).forEach((root) => cleanups.get(root)?.());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initScope(), { once: true }); else initScope();
  document.addEventListener('shopify:section:load', (event) => initScope(event.target));
  document.addEventListener('shopify:section:unload', (event) => cleanupScope(event.target));
})();
